function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useEffect, useState } from 'react';
import { ListingType, RentalType } from '@domain-group/fe-allhomes-library';
import { SearchQuery } from '@domain-group/fe-allhomes-search-api';
import { BTR_MORE_RESULTS_DISPLAY_THRESHOLD, BTR_MORE_RESULTS_EXPANDED_LOCALITIES, BTR_MORE_RESULTS_MAX_ADDITIONAL_LISTINGS } from './btr-more-config';
var doAdditionalSearch = async (buildSearchApi, listingTypeName, filters, pageSize, expandedBTRSearch) => {
  var searchApi = buildSearchApi();
  var listingType = ListingType[listingTypeName];
  var newFilters;
  if (expandedBTRSearch) {
    newFilters = filters.cloneWith({
      listedPropertyTypes: [RentalType.BUILD_TO_RENT.name],
      localities: BTR_MORE_RESULTS_EXPANDED_LOCALITIES
    });
  } else {
    newFilters = filters.cloneWith({
      listedPropertyTypes: filters.listedPropertyTypes.default
    });
  }
  var query = new SearchQuery(listingTypeName, newFilters, {
    pageSize
  });
  return searchApi.fetchListings(listingType, query);
};
var useListingSearch = (initSearchResults, initTotalHits, primarySearchResult, buildSearchApi, listingTypeName, filters, isExpandedSearch) => {
  var _useState = useState(initSearchResults),
    _useState2 = _slicedToArray(_useState, 2),
    searchResults = _useState2[0],
    setSearchResults = _useState2[1];
  var _useState3 = useState(initTotalHits),
    _useState4 = _slicedToArray(_useState3, 2),
    totalHits = _useState4[0],
    setTotalHits = _useState4[1];
  var listingIdsDep = JSON.stringify(primarySearchResult.listingIds);
  useEffect(() => {
    if (primarySearchResult.totalHits <= BTR_MORE_RESULTS_DISPLAY_THRESHOLD) {
      doAdditionalSearch(buildSearchApi, listingTypeName, filters, BTR_MORE_RESULTS_MAX_ADDITIONAL_LISTINGS + primarySearchResult.totalHits, isExpandedSearch).then(newSearchResults => {
        if (primarySearchResult.totalHits > BTR_MORE_RESULTS_DISPLAY_THRESHOLD) {
          setSearchResults([]);
          setTotalHits(0);
        } else {
          var finalAdditionalListings = newSearchResults.searchResults.filter(result => {
            var _result$development;
            if (isExpandedSearch) {
              return !primarySearchResult.listingIds.includes(Number(result.listing.id));
            }
            return ((_result$development = result.development) === null || _result$development === void 0 ? void 0 : _result$development.type) !== 'RENTAL';
          });
          setSearchResults(finalAdditionalListings.slice(0, BTR_MORE_RESULTS_MAX_ADDITIONAL_LISTINGS));
          setTotalHits(newSearchResults.totalHits);
        }
      });
    } else {
      setSearchResults([]);
      setTotalHits(0);
    }
  }, [buildSearchApi, filters, listingTypeName, primarySearchResult.totalHits, listingIdsDep, isExpandedSearch]);
  return {
    searchResults,
    totalHits
  };
};
export { useListingSearch };